const animationName = 'buttonSpinner';

export const spinnerStyles = theme => ({
  spinner: {
    display: 'inline-block',
    width: 16,
    height: 16,
    border: `2px solid ${theme.white1}4D`,
    borderTopColor: theme.white1,
    borderRadius: '50%',
    verticalAlign: 'middle',
    animationName,
    animationDuration: '0.6s',
    animationTimingFunction: 'linear',
    animationIterationCount: 'infinite'
  },
  [`@keyframes ${animationName}`]: {
    from: { transform: 'rotate(0deg)' },
    to: { transform: 'rotate(360deg)' }
  }
});
